import {
    trigger,
} from '@utils/event';
import { convertKeyFromEvent } from './convert-key';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import throttle from 'lodash/throttle';
import { IpadExternalKeyboardEventManager } from './ipad-external-keyboard';

const EVENT_MAX_PERIOD = 300; // 事件触发的最大允许间隔
const KEYDOWN_THROTTLE_PERIOD = 120; // 节流间隔

/**
 * 判断事件是否合理
 * 在 300ms 内触发的事件才合理
 */
export const isMacMiniInvalidICallback = (e) => {
    if (!e?.timeStamp || !performance?.timing?.navigationStart) {
        return;
    }
    if (!(browser.isMac && browser.isWxMiniProgram)) {
        return;
    }
    return Math.abs(e.timeStamp - (Date.now() - performance.timing?.navigationStart)) > EVENT_MAX_PERIOD;
};

// TODO modifier？
window.addEventListener('keydown', (e) => {
    // mac微信小程序 部分版本存在bug，回调会一直触发，所以加入限制，不在合理时间范围内的回调会被忽略（timeStamp为文档初始化到触发的间隔）
    if (isMacMiniInvalidICallback(e)) {
        return;
    }
    trigger(convertKeyFromEvent(e, 'keydown'), e);
}, true);

window.addEventListener('keyup', () => {
    // trigger(convertKeyFromEvent(e, 'keyup'), e);
}, true);

window.addEventListener('keypress', () => {
    // trigger(convertKeyFromEvent(e, 'keypress'), e);
}, true);

/**
 * 节流按键事件
 */
const throttleTriggerKeyDown = throttle((e) => {
    trigger(convertKeyFromEvent(e, 'keydown', {
        bubble: true,
    }), e);
}, KEYDOWN_THROTTLE_PERIOD, { trailing: false });

window.addEventListener('keydown', (e) => {
    // mac微信小程序，回调会一直触发，所以不在合理时间范围内的回调会被忽略
    if (isMacMiniInvalidICallback(e)) {
        return;
    }
    // mac微信小程序，合理时间范围内的事件节流触发，以防多次触发
    if (browser.isMac && browser.isWxMiniProgram) {
        throttleTriggerKeyDown(e);
        return;
    }
    trigger(convertKeyFromEvent(e, 'keydown', {
        bubble: true,
    }), e);
});

IpadExternalKeyboardEventManager.addShortcutKeyEventListener((event) => {
    if (event) {
        triggerIpadExternalKeyEvent(event);
    }
});

export const triggerIpadExternalKeyEvent = (e) => {
    trigger(convertKeyFromEvent(e, 'keydown'), e);
    trigger(convertKeyFromEvent(e, 'keydown', {
        bubble: true,
    }), e);
};
